function ListePartenaires() {
  const partenaires = [
    ['CNJE', './images/logo_cnje.svg'],
    ['BNP Paribas', './images/logo_bnp.svg'],
    ['AEI', './images/logo_aei.svg'],
    ['Talence Innovation Sud Développement', './images/logo_tisd.svg'],
    ['Bordeaux INPulse', './images/logo_inpulse.svg'],
  ];

  return (
    <div>
      <ul className="flex flex-wrap justify-center items-center gap-6 sm:gap-10 md:gap-[74px]">
        {partenaires.map((partenaire, index) => (
          <li key={index} className="flex justify-center items-center">
            <img 
              src={partenaire[1]} 
              alt={partenaire[0]} 
              className="h-14 sm:h-20 md:h-24 w-auto max-w-[160px] object-contain"
            />
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ListePartenaires;